(() => {
  const boot = () => {
    const header = document.querySelector("[data-header]");

    const onScroll = () => {
      if (!header) return;
      header.classList.toggle("is-scrolled", window.scrollY > 24);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    // ===== Header v2 navigation (Oct 3, 2026) =====
    const navItems = Array.from(document.querySelectorAll("[data-nav-item]"));
    const searchBtn = document.querySelector("[data-search-toggle]");
    const searchPanel = document.getElementById("hsearch");
    const canHover = window.matchMedia("(hover: hover) and (pointer: fine)");
    const isDesktop = () => window.matchMedia("(min-width: 901px)").matches;
    const triggerOf = (item) => item.querySelector("[data-nav-trigger]");
    const menuLinks = (item) => Array.from(item.querySelectorAll(".hnav__menu a"));

    const setItem = (item, open) => {
      const t = triggerOf(item);
      if (!t) return;
      item.classList.toggle("is-open", open);
      t.setAttribute("aria-expanded", String(open));
    };
    const closeAll = (except) => {
      navItems.forEach((item) => {
        if (item !== except) setItem(item, false);
      });
    };
    const setSearch = (open, focusInput) => {
      if (!searchBtn || !searchPanel) return;
      searchBtn.setAttribute("aria-expanded", String(open));
      searchPanel.hidden = !open;
      if (open) {
        closeAll();
        if (focusInput) searchPanel.querySelector("input[type=search]")?.focus();
      }
    };

    navItems.forEach((item) => {
      const trigger = triggerOf(item);
      if (!trigger) return;
      let timer;
      trigger.addEventListener("click", () => {
        const willOpen = !item.classList.contains("is-open");
        closeAll(item);
        setSearch(false);
        setItem(item, willOpen);
      });
      item.addEventListener("pointerenter", (e) => {
        if (e.pointerType !== "mouse" || !canHover.matches) return;
        clearTimeout(timer);
        closeAll(item);
        setSearch(false);
        setItem(item, true);
      });
      item.addEventListener("pointerleave", (e) => {
        if (e.pointerType !== "mouse") return;
        timer = setTimeout(() => setItem(item, false), 160);
      });
      item.addEventListener("focusout", (e) => {
        if (!item.contains(e.relatedTarget)) setItem(item, false);
      });
      item.addEventListener("keydown", (e) => {
        const links = menuLinks(item);
        const open = item.classList.contains("is-open");
        if (e.key === "Escape" && open) {
          e.preventDefault();
          setItem(item, false);
          trigger.focus();
        } else if (e.key === "ArrowDown") {
          e.preventDefault();
          if (!open) setItem(item, true);
          const i = links.indexOf(document.activeElement);
          (links[i + 1] || links[0])?.focus();
        } else if (e.key === "ArrowUp" && open) {
          e.preventDefault();
          const i = links.indexOf(document.activeElement);
          if (i <= 0) trigger.focus();
          else links[i - 1].focus();
        } else if ((e.key === "Home" || e.key === "End") && links.includes(document.activeElement)) {
          e.preventDefault();
          (e.key === "Home" ? links[0] : links[links.length - 1])?.focus();
        }
      });
    });

    // Left and right arrows move between top level items
    const topStops = Array.from(document.querySelectorAll(".hnav__list > li > .hnav__link, .hnav__list > li > .hnav__trigger"));
    topStops.forEach((el, idx) => {
      el.addEventListener("keydown", (e) => {
        if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
        e.preventDefault();
        const next = topStops[(idx + (e.key === "ArrowRight" ? 1 : -1) + topStops.length) % topStops.length];
        next.focus();
      });
    });

    if (searchBtn) {
      searchBtn.addEventListener("click", () => setSearch(searchBtn.getAttribute("aria-expanded") !== "true", true));
    }
    document.addEventListener("click", (e) => {
      if (!e.target.closest("[data-nav-item]")) closeAll();
      if (searchPanel && !searchPanel.hidden && !e.target.closest("#hsearch, [data-search-toggle]")) setSearch(false);
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && searchPanel && !searchPanel.hidden) {
        setSearch(false);
        searchBtn?.focus();
      }
    });

    // Mobile drawer
    const drawer = document.querySelector("[data-mobile-nav]");
    const toggle = document.querySelector("[data-nav-toggle]");
    const closeBtn = document.querySelector("[data-nav-close]");
    if (drawer && toggle) {
      const focusables = () =>
        Array.from(drawer.querySelectorAll("a[href], button:not([disabled]), input:not([type=hidden])")).filter(
          (el) => el.offsetParent !== null
        );
      const openDrawer = () => {
        drawer.hidden = false;
        toggle.setAttribute("aria-expanded", "true");
        document.documentElement.classList.add("nav-open");
        (closeBtn || focusables()[0])?.focus();
      };
      const closeDrawer = (returnFocus) => {
        if (drawer.hidden) return;
        drawer.hidden = true;
        toggle.setAttribute("aria-expanded", "false");
        document.documentElement.classList.remove("nav-open");
        if (returnFocus) toggle.focus();
      };
      toggle.addEventListener("click", openDrawer);
      closeBtn?.addEventListener("click", () => closeDrawer(true));
      drawer.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          e.preventDefault();
          closeDrawer(true);
        } else if (e.key === "Tab") {
          const f = focusables();
          if (!f.length) return;
          const first = f[0];
          const last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      });
      drawer.querySelectorAll(".hdrawer__toggle").forEach((btn) => {
        const panel = document.getElementById(btn.getAttribute("aria-controls"));
        btn.addEventListener("click", () => {
          const open = btn.getAttribute("aria-expanded") === "true";
          btn.setAttribute("aria-expanded", String(!open));
          if (panel) panel.hidden = open;
        });
      });
      drawer.querySelectorAll("a").forEach((a) =>
        a.addEventListener("click", () => {
          document.documentElement.classList.remove("nav-open");
        })
      );
      window.matchMedia("(min-width: 901px)").addEventListener("change", (e) => {
        if (e.matches) closeDrawer(false);
      });
    }

    const reveals = document.querySelectorAll(".reveal");
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0, rootMargin: "0px 0px -5% 0px" }
      );
      reveals.forEach((el) => io.observe(el));
    } else {
      reveals.forEach((el) => el.classList.add("is-visible"));
    }

    const parallax = document.querySelector("[data-parallax], .hero-image");
    if (parallax && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      let ticking = false;
      window.addEventListener(
        "scroll",
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            const y = Math.min(window.scrollY, window.innerHeight);
            parallax.style.translate = `0 ${y * 0.12}px`;
            ticking = false;
          });
        },
        { passive: true }
      );
    }

    // Product form: purchase mode + grind options + qty + selling plan
    document.querySelectorAll("[data-buy-box]").forEach((box) => {
      const form = box.tagName === "FORM" ? box : box.closest("form") || box;
      const planSelect = form.querySelector("[data-selling-plan]");
      const options = form.querySelectorAll("[data-purchase]");
      const subPanel = form.querySelector("[data-sub-panel]");
      const forceSub = subPanel?.hasAttribute("data-force-sub");
      const qtyInput = form.querySelector("[data-qty-input]");
      const qtyMinus = form.querySelector("[data-qty-minus]");
      const qtyPlus = form.querySelector("[data-qty-plus]");
      const variantInput = form.querySelector("[data-variant-id]");
      const productJsonEl = document.querySelector("[data-product-json]");
      let product = null;
      try {
        product = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
      } catch (_) {}

      let mode = forceSub ? "subscribe" : "onetime";

      const syncPlan = () => {
        if (!planSelect) return;
        if (forceSub || mode === "subscribe") {
          subPanel?.classList.add("is-visible");
          if (!planSelect.value) {
            const firstPlan = [...planSelect.options].find((o) => o.value);
            if (firstPlan) planSelect.value = firstPlan.value;
          }
        } else {
          subPanel?.classList.remove("is-visible");
          planSelect.value = "";
        }
        options.forEach((btn) => {
          btn.classList.toggle("is-active", btn.getAttribute("data-purchase") === mode);
        });
      };

      options.forEach((btn) => {
        btn.addEventListener("click", () => {
          mode = btn.getAttribute("data-purchase") || "onetime";
          syncPlan();
        });
      });

      // Option buttons → variant id
      const optionGroups = [...form.querySelectorAll("[data-option-index]")];
      const selected = {};
      optionGroups.forEach((group) => {
        const idx = group.getAttribute("data-option-index");
        const active = group.querySelector(".grind-option.is-active");
        if (active) selected[idx] = active.getAttribute("data-option-value");
        group.querySelectorAll("[data-option-value]").forEach((btn) => {
          btn.addEventListener("click", () => {
            group.querySelectorAll(".grind-option").forEach((b) => b.classList.remove("is-active"));
            btn.classList.add("is-active");
            selected[idx] = btn.getAttribute("data-option-value");
            if (!product || !variantInput) return;
            const match = product.variants.find((v) =>
              Object.keys(selected).every((i) => v[`option${Number(i) + 1}`] === selected[i])
            );
            if (match) variantInput.value = match.id;
          });
        });
      });

      qtyMinus?.addEventListener("click", () => {
        if (!qtyInput) return;
        qtyInput.value = String(Math.max(1, Number(qtyInput.value || 1) - 1));
      });
      qtyPlus?.addEventListener("click", () => {
        if (!qtyInput) return;
        qtyInput.value = String(Number(qtyInput.value || 1) + 1);
      });

      syncPlan();
    });

    // YouTube click-to-play
    document.querySelectorAll("[data-youtube-id]").forEach((el) => {
      const id = el.getAttribute("data-youtube-id");
      const title = el.getAttribute("data-youtube-title") || "Video";
      const fallback = el.querySelector(".video-embed__fallback");
      if (!id || !fallback) return;
      fallback.addEventListener("click", (e) => {
        e.preventDefault();
        el.innerHTML =
          '<iframe src="https://www.youtube.com/embed/' +
          id +
          '?autoplay=1" title="' +
          title.replace(/"/g, "") +
          '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe>';
      });
    });

    // Hide Seal / app selling-plan widgets that duplicate our .sub-panel
    const hideDupSubscriptionUi = () => {
      document.querySelectorAll('select[name="selling_plan"]').forEach((sel) => {
        if (sel.closest("[data-sub-panel], .sub-panel")) return;
        const wrap =
          sel.closest(
            ".seal-selling-plan-widget, .seal-subscription-widget, .seal-widget, [data-seal-widget], .sealsubs-widget, .sealsubs-container, .shopify-app-block, .shopify-block, purchase-options-wrapper"
          ) || sel.parentElement;
        if (wrap) wrap.style.setProperty("display", "none", "important");
      });
      document
        .querySelectorAll(
          ".seal-selling-plan-widget, .seal-subscription-widget, .seal-widget, [data-seal-widget], .sealsubs-widget, .sealsubs-container"
        )
        .forEach((el) => {
          if (el.closest(".buy-box .sub-panel")) return;
          el.style.setProperty("display", "none", "important");
        });
    };
    hideDupSubscriptionUi();
    const mo = new MutationObserver(hideDupSubscriptionUi);
    mo.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

// ===== Coffee belt tooltip (Oct 2026). Append to assets/syzygy.js =====
// Binds every [data-coffee-belt] rendered by snippets/coffee-belt-tooltip.liquid, and upgrades any
// leftover rich text marker <span class="coffee-belt">coffee belt</span> as a safety net.
(() => {
  // Fallback copy for the safety net only. The source of truth is snippets/coffee-belt-tooltip.liquid.
  const TIP_ES = (document.documentElement.lang || "").toLowerCase().indexOf("es") === 0;
  const TIP_COPY = TIP_ES
    ? "El café es exigente. Solo crece en la franja cálida entre los trópicos, en un grupo selecto de países con el suelo y el clima que necesita, como Etiopía, Kenia, Colombia, Venezuela, El Salvador y Brasil."
    : "Coffee is picky. It only grows in the warm band between the tropics, in a select group of countries with the soil and weather it needs, like Ethiopia, Kenya, Colombia, Venezuela, El Salvador and Brazil.";
  const MARGIN = 8;
  const roots = new Set();
  let auto = 0;

  const upgradeMarker = (marker) => {
    const label = (marker.textContent || "").trim() || (TIP_ES ? "cinturón del café" : "coffee belt");
    const id = "coffee-belt-tip-auto-" + ++auto;
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "coffee-belt__trigger";
    btn.textContent = label;
    btn.setAttribute("aria-describedby", id);
    const tip = document.createElement("span");
    tip.className = "coffee-belt__tip";
    tip.id = id;
    tip.setAttribute("role", "tooltip");
    tip.textContent = TIP_COPY;
    marker.textContent = "";
    marker.setAttribute("data-coffee-belt", "");
    marker.append(btn, tip);
  };

  const headerBottom = () => {
    const h = document.querySelector("[data-header]");
    if (!h) return 0;
    const r = h.getBoundingClientRect();
    return r.bottom > 0 ? r.bottom : 0;
  };

  // Called right after the tip is shown (same frame, before paint): nudge it inside the viewport or flip below.
  const place = (root, tip) => {
    root.style.removeProperty("--cb-shift");
    root.removeAttribute("data-placement");
    let r = tip.getBoundingClientRect();
    if (r.top < headerBottom() + MARGIN) {
      root.setAttribute("data-placement", "below");
      r = tip.getBoundingClientRect();
    }
    const vw = document.documentElement.clientWidth;
    let shift = 0;
    if (r.left < MARGIN) shift = MARGIN - r.left;
    else if (r.right > vw - MARGIN) shift = vw - MARGIN - r.right;
    if (shift) root.style.setProperty("--cb-shift", Math.round(shift) + "px");
  };

  const init = (root) => {
    if (root.hasAttribute("data-cb-ready")) return;
    const btn = root.querySelector(".coffee-belt__trigger");
    const tip = root.querySelector(".coffee-belt__tip");
    if (!btn || !tip) return;
    // keep ids unique if the same placement id appears twice on a page
    if (document.querySelectorAll("#" + CSS.escape(tip.id)).length > 1) {
      tip.id = "coffee-belt-tip-auto-" + ++auto;
      btn.setAttribute("aria-describedby", tip.id);
    }
    let pinned = false;
    let timer;
    const open = (pin) => {
      clearTimeout(timer);
      roots.forEach((r) => r !== root && r.cbClose());
      if (!root.hasAttribute("data-open")) {
        root.setAttribute("data-open", "");
        place(root, tip);
      }
      btn.setAttribute("aria-expanded", "true");
      if (pin) pinned = true;
    };
    const close = () => {
      clearTimeout(timer);
      pinned = false;
      root.removeAttribute("data-open");
      btn.setAttribute("aria-expanded", "false");
    };
    root.cbClose = close;
    root.cbIsOpen = () => root.hasAttribute("data-open");

    root.addEventListener("pointerenter", (e) => {
      if (e.pointerType === "mouse") open(false);
    });
    root.addEventListener("pointerleave", (e) => {
      if (e.pointerType !== "mouse" || pinned || document.activeElement === btn) return;
      timer = setTimeout(close, 150);
    });
    btn.addEventListener("focus", () => open(false));
    root.addEventListener("focusout", (e) => {
      if (!root.contains(e.relatedTarget)) close();
    });
    btn.addEventListener("click", () => {
      if (pinned) close();
      else open(true);
    });

    btn.setAttribute("aria-expanded", "false");
    root.setAttribute("data-cb-ready", "");
    roots.add(root);
  };

  const boot = () => {
    document.querySelectorAll(".coffee-belt:not([data-coffee-belt])").forEach(upgradeMarker);
    document.querySelectorAll("[data-coffee-belt]").forEach(init);
    if (!roots.size) return;
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" || e.key === "Esc") roots.forEach((r) => r.cbIsOpen() && r.cbClose());
    });
    document.addEventListener("pointerdown", (e) => {
      roots.forEach((r) => r.cbIsOpen() && !r.contains(e.target) && r.cbClose());
    });
    window.addEventListener("resize", () => roots.forEach((r) => r.cbIsOpen() && r.cbClose()));
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();

/* Cart page: live quantity updates for the free shipping bar, subtotal and line prices (Oct 8 2026).
   Progressive enhancement: without JS the Update cart button still posts the form. Uses /cart/update.js and the
   Section Rendering API (section_id) so all numbers come from Liquid. */
(() => {
  const boot = () => {
    const section = document.querySelector("[data-cart-section]");
    const form = section && section.querySelector("[data-cart-form]");
    if (!section || !form || !window.fetch) return;
    const sectionId = section.getAttribute("data-cart-section");
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    let timer = null;
    let seq = 0;

    const swapBar = (doc) => {
      const cur = section.querySelector("[data-ship-bar]");
      const next = doc.querySelector("[data-ship-bar]");
      if (!cur || !next) return;
      cur.className = next.className;
      cur.hidden = next.hidden;
      const msg = cur.querySelector("[data-ship-bar-msg]");
      const nmsg = next.querySelector("[data-ship-bar-msg]");
      if (msg && nmsg && msg.innerHTML.trim() !== nmsg.innerHTML.trim()) msg.innerHTML = nmsg.innerHTML;
      const track = cur.querySelector("[data-ship-bar-track]");
      const ntrack = next.querySelector("[data-ship-bar-track]");
      if (track && ntrack) {
        ["aria-valuenow", "aria-valuetext"].forEach((a) => track.setAttribute(a, ntrack.getAttribute(a)));
        const fill = cur.querySelector("[data-ship-bar-fill]");
        const nfill = next.querySelector("[data-ship-bar-fill]");
        if (fill && nfill) fill.setAttribute("style", nfill.getAttribute("style"));
      }
      const extra = cur.querySelector("[data-ship-bar-extra]");
      const nextra = next.querySelector("[data-ship-bar-extra]");
      if (extra && nextra) extra.innerHTML = nextra.innerHTML;
    };

    const updateCount = (count) => {
      document.querySelectorAll(".hcart").forEach((a) => {
        const es = (document.documentElement.lang || "").toLowerCase().indexOf("es") === 0;
        a.setAttribute("aria-label", es
          ? (count > 0 ? `Carrito, ${count} ${count === 1 ? "artículo" : "artículos"}` : "Carrito")
          : (count > 0 ? `Cart, ${count} item${count === 1 ? "" : "s"}` : "Cart"));
        const badge = a.querySelector(".hcart__count");
        if (badge) badge.textContent = count;
      });
    };

    const run = async () => {
      const my = ++seq;
      const updates = Array.from(form.querySelectorAll("[data-cart-qty]")).map((i) => Math.max(0, parseInt(i.value, 10) || 0));
      section.querySelector("[data-ship-bar]")?.classList.add("cart-live-busy");
      try {
        const post = () => fetch(`${root}cart/update.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ updates }),
        });
        let res = await post();
        if (!res.ok) {
          await new Promise((r) => setTimeout(r, 700));
          res = await post();
        }
        if (!res.ok) throw new Error(`cart update ${res.status}`);
        const cart = await res.json();
        const html = await (await fetch(`${root}cart?section_id=${encodeURIComponent(sectionId)}`)).text();
        if (my !== seq) return;
        const doc = new DOMParser().parseFromString(html, "text/html");
        const nextLines = doc.querySelectorAll("[data-cart-line]").length;
        const curLines = form.querySelectorAll("[data-cart-line]").length;
        updateCount(cart.item_count);
        if (cart.item_count === 0 || nextLines !== curLines) {
          const inner = doc.querySelector("[data-cart-section]");
          if (inner) { section.innerHTML = inner.innerHTML; boot(); return; }
          window.location.reload();
          return;
        }
        swapBar(doc);
        section.querySelectorAll("[data-cart-live]").forEach((el) => {
          const n = doc.querySelector(`[data-cart-live="${el.getAttribute("data-cart-live")}"]`);
          if (n) el.innerHTML = n.innerHTML;
        });
      } catch (e) {
        form.submit();
      } finally {
        section.querySelector("[data-ship-bar]")?.classList.remove("cart-live-busy");
      }
    };

    form.addEventListener("input", (e) => {
      if (!e.target.matches("[data-cart-qty]") || e.target.value === "") return;
      clearTimeout(timer);
      timer = setTimeout(run, 450);
    });
    form.addEventListener("change", (e) => {
      if (!e.target.matches("[data-cart-qty]")) return;
      clearTimeout(timer);
      timer = setTimeout(run, 150);
    });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
